export const SQUARE_SERVICES_URL =
  'https://book.squareup.com/appointments/8hgx95pz2lqzj0/location/LCWRGV6THEEAC/services';

